/** Shared chrome fill — solid muted + input border so controls read on bg-background. */
export const SURFACE_CONTROL_CLS =
  "border border-input bg-muted text-foreground/80 shadow-sm";

/** Rounded icon control for file browser / detail toolbars. */
export const SURFACE_ICON_BTN_CLS =
  `size-9 shrink-0 rounded-full ${SURFACE_CONTROL_CLS} transition-[transform,background-color,color,border-color] duration-150 ease-out hover:border-input-enhanced hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring active:scale-[0.97] motion-reduce:active:scale-100`;

/** Rounded search field matching file browser toolbar density. */
export const SURFACE_SEARCH_CLS =
  `flex h-9 w-full rounded-full ${SURFACE_CONTROL_CLS} pl-9 pr-9 text-sm outline-none placeholder:text-sm placeholder:text-muted-foreground focus-visible:border-ring focus-visible:text-foreground focus-visible:ring-1 focus-visible:ring-ring`;
